import React, { useEffect, useRef, useState } from "react";
import { objectiveFilterType } from "../../../types";

interface Props {
  data: any;
  setCheckBoxes: (id: string) => void;
  setShowMultiSelect: (state: boolean) => void;
  title: string;
}

const CustomeMultiSelect = ({
  data,
  setCheckBoxes,
  setShowMultiSelect,
  title,
}: Props) => {
  const [clickedOutside, setClickedOutside] = useState(false);
  const myRef = useRef<HTMLInputElement>(null);
  const handleClickOutside = (e: any) => {
    if (
      !(myRef.current as any).contains(e.target) &&
      e.target.textContent !== title
    ) {
      setShowMultiSelect(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });
  return (
    <div
      ref={myRef}
      className="card card-compact rounded-md flex flex-col overflow-hidden  bg-white z-20 justify-start  shadow-2xl shadow-black "
    >
      <div className="flex flex-col justify-start max-h-36 2xl:max-h-56 px-4 pb-1 mt-1  overflow-y-auto">
        {data.map((item: any) => (
          <div
            key={item.id}
            className={`w-full flex my-1 items-center text-2xs`}
          >
            <input
              type="checkbox"
              name={item.id}
              // value={item.id}
              onChange={() => setCheckBoxes(item.id)}
              defaultChecked={item.checked}
              className="checkbox checkbox-xs ml-1 mr-2  "
            />{" "}
            <span className="">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomeMultiSelect;
